import { ADMIN_CANCEL_SUBSCRIPTION_API_SLUG, ADMIN_PAYMENT_DETAILS_API_SLUG, ADMIN_SUBSCRIPTION_STATS_API_SLUG, CANCEL_SUBSCRIPTION_API_SLUG, CREATE_COUPON_API_SLUG, CREATE_NEW_PRICING_PLAN_SLUG, CREATE_SUBSCRIPTION_API_SLUG, DELETE_COUPON_API_SLUG, DELETE_EXISTING_PLAN_SLUG, GET_ALL_COUPONS_API_SLUG, GET_ALL_PRICING_PLANS_ADMIN_SLUG, GET_ALL_PRICING_PLANS_SLUG, GET_ALL_SUBSCRIBERS_SLUG, GET_COUPON_BY_CODE_API_SLUG, GET_SUBSCRIBER_REMAINING_SLUG, PAUSE_SUBSCRIPTION_API_SLUG, PAYMENT_INVOICES_API_SLUG, RESUME_SUBSCRIPTION_API_SLUG, UPDATE_EXISTING_PLAN_SLUG, UPDATE_PAYMENT_INFO_API_SLUG, UPDATE_POPULAR_PLANS_SLUG, UPDATE_SUBSCRIBER_REMAINING_SLUG, UPDATE_SUBSCRIPTION_API_SLUG, VERIFY_SESSION_API_SLUG } from "../constants/Api_constants";
import { axiosOpen, axiosSecureInstance } from "./axios";
const COMMON_ERROR_MESSAGE = "Something went wrong!";

export const getPricingPlans = async () => {
  try {
    const response = await axiosOpen.get(GET_ALL_PRICING_PLANS_SLUG());
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const getAdminPricingPlans = async () => {
  try {
    const response = await axiosSecureInstance.get(GET_ALL_PRICING_PLANS_ADMIN_SLUG());
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const updatePopularPlans = async (data) => {
  try {
    const response = await axiosSecureInstance.put(UPDATE_POPULAR_PLANS_SLUG(), data);
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const createNewPricingPlan = async (data) => {
  try {
    const response = await axiosSecureInstance.post(CREATE_NEW_PRICING_PLAN_SLUG(), data);
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const updateExistingPlan = async (id, data) => {
  try {
    const response = await axiosSecureInstance.put(UPDATE_EXISTING_PLAN_SLUG(id), data);
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const deleteExistingPlan = async (id) => {
  try {
    const response = await axiosSecureInstance.delete(DELETE_EXISTING_PLAN_SLUG(id));
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || COMMON_ERROR_MESSAGE;
    throw new Error(errorMessage);
  }
};

export const createSubscription = async (data) => {
  try {
    const response = await axiosSecureInstance.post(CREATE_SUBSCRIPTION_API_SLUG(), data);
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const updateSubscription = async (data) => {
  try {
    const response = await axiosSecureInstance.post(UPDATE_SUBSCRIPTION_API_SLUG(), data);
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const verifySession = async (session_id, planId) => {
  try {
    const response = await axiosSecureInstance.get(VERIFY_SESSION_API_SLUG(session_id, planId));
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const getUpdatePaymentInfo = async () => {
  try {
    const response = await axiosSecureInstance.get(UPDATE_PAYMENT_INFO_API_SLUG());
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const cancelSubscription = async () => {
  try {
    const response = await axiosSecureInstance.delete(CANCEL_SUBSCRIPTION_API_SLUG());
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const getPaymentInvoices = async () => {
  try {
    const response = await axiosSecureInstance.get(PAYMENT_INVOICES_API_SLUG());
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const getSubscriberList = async () => {
  try {
    const response = await axiosSecureInstance.get(GET_ALL_SUBSCRIBERS_SLUG());
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const getSubscriberRemaining = async (id) => {
  try {
    const response = await axiosSecureInstance.get(GET_SUBSCRIBER_REMAINING_SLUG(id));
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const updateSubscriberRemaining = async (id, data) => {
  try {
    const response = await axiosSecureInstance.put(UPDATE_SUBSCRIBER_REMAINING_SLUG(id), data);
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const pauseSubscription = async (id) => {
  try {
    const response = await axiosSecureInstance.put(PAUSE_SUBSCRIPTION_API_SLUG(id));
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const resumeSubscription = async (id) => {
  try {
    const response = await axiosSecureInstance.put(RESUME_SUBSCRIPTION_API_SLUG(id));
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const adminCancelSubscription = async (id) => {
  try {
    const response = await axiosSecureInstance.put(ADMIN_CANCEL_SUBSCRIPTION_API_SLUG(id));
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const getSubscriptionStats = async () => {
  try {
    const response = await axiosSecureInstance.get(ADMIN_SUBSCRIPTION_STATS_API_SLUG());
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const getPaymentInfo = async () => {
  try {
    const response = await axiosSecureInstance.get(ADMIN_PAYMENT_DETAILS_API_SLUG());
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};


export const getCoupons = async () => {
  try {
    const response = await axiosSecureInstance.get(GET_ALL_COUPONS_API_SLUG());
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const createNewCoupon = async (data) => {
  try {
    const response = await axiosSecureInstance.post(CREATE_COUPON_API_SLUG(), data);
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const deleteCoupon = async (id) => {
  try {
    const response = await axiosSecureInstance.delete(DELETE_COUPON_API_SLUG(id));
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const getCouponByCode = async (code) => {
  try {
    const response = await axiosSecureInstance.get(GET_COUPON_BY_CODE_API_SLUG(code));
    return response;
  } catch (error) {
    console.log(error);
    return;
  }
};